import { Component, Input, OnInit } from '@angular/core';
import {
	iacOptionInterface,
	InputWithAutocompleteComponent,
} from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { SearchInformationService } from './service/search-information.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { DotBounceLoadingEffectComponent } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.component';

@Component({
	standalone: true,
	imports: [CommonModule, GenericFormGenModule, FontAwesomeModule, InputWithAutocompleteComponent, DotBounceLoadingEffectComponent],
	selector: 'pcp-search-information',
	templateUrl: './search-information.component.html',
	styleUrl: './search-information.component.scss',
})
export class SearchInformationComponent implements OnInit {
	@Input()
	labels = {
		lbl_buscar_dados_usuario: 'lbl_buscar_dados_usuario',
		lbl_geral_buscar: 'lbl_geral_buscar',
		lbl_geral_pesquisar: 'lbl_geral_pesquisar',
		lbl_iac_min_char_search: 'lbl_iac_min_char_search',
		lbl_geral_cliente: 'lbl_geral_cliente',
		lbl_geral_nome: 'lbl_geral_nome',
		lbl_geral_email: 'lbl_geral_email',
		lbl_geral_login: 'lbl_geral_login',
		lbl_chave_unica: 'lbl_chave_unica',
		lbl_geral_telefone: 'lbl_geral_telefone',
	};

	@Input()
	idCustomer: number = undefined;

	icons = {
		faAngleUp: faAngleUp,
		faAngleDown: faAngleDown,
	};

	constructor(
		private SearchInformationServie: SearchInformationService,
		public ProfileService: ProfileService
	) {}

	isUserDataSearchOpen = false;
	isLoadingUserDataSearch = false;
	searchUserForm: genericFormInterface[] = [
		{
			name: 'full_name',
			label: 'lbl_geral_nome',
			inputType: 'string',
			values: [''],
		},
		{
			name: 'email',
			label: 'lbl_geral_email',
			inputType: 'string',
			values: [''],
		},
		{
			name: 'login',
			label: 'lbl_geral_login',
			inputType: 'string',
			values: [''],
		},
	];
	searchUserDictionary = {};
	searchUserData: iacOptionInterface[] = [];
	selectedUser: enduserInterface;

	ngOnInit(): void {}

	getUserData(): void {
		if (this.isLoadingUserDataSearch) return;

		this.isLoadingUserDataSearch = true;
		this.searchUserData = [];
		this.SearchInformationServie.searchUserData(this.searchUserForm, this.idCustomer).subscribe({
			next: (userRes) => {
				for (const userData of userRes) {
					const newIac: iacOptionInterface = {
						name: userData.fullName,
						value: userData.id,
						secondName: userData.email,
					};
					this.searchUserDictionary[userData.id] = userData;
					this.searchUserData.push(newIac);
				}
			},
			complete: () => {
				this.isLoadingUserDataSearch = false;
			},
		});
	}
}
